import React from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { SectionHeader } from "@/components/common/Widgets";
import { fmtDate } from "@/lib/format";
import { GitBranchPlus, ShieldCheck, ClipboardCheck } from "lucide-react";

export default function MakerCheckerActions({ app, pending = [], reload }) {
  const submit = async (action_type) => {
    try {
      await api.post("/maker-checker/submit", { application_id: app.id, action_type, remarks: "" });
      toast.success("Submitted for approval");
      reload && reload();
    } catch (e) { toast.error("Failed"); }
  };
  return (
    <div className="space-y-3">
      <SectionHeader title="Two-Eyes Approvals (Maker-Checker)" subtitle="Submit critical actions for second-level approval." />
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        {[
          { code: "CMA_FINALIZE", label: "Finalize & Lock CMA", icon: ShieldCheck },
          { code: "CRA_FINALIZE", label: "Finalize & Lock CRA", icon: ShieldCheck },
          { code: "S_FORMAT_FINALIZE", label: "Finalize S-Format", icon: ClipboardCheck },
          { code: "SANCTION", label: "Sanction Loan", icon: ShieldCheck },
          { code: "CMA_NEW_VERSION", label: "Unlock CMA → New Version", icon: GitBranchPlus },
          { code: "CRA_NEW_VERSION", label: "Unlock CRA → New Version", icon: GitBranchPlus },
        ].map(a => (
          <Card key={a.code} className="p-3 flex items-center justify-between">
            <div className="flex items-center gap-2"><a.icon className="h-4 w-4 text-accent" /><span className="text-sm font-medium">{a.label}</span></div>
            <Button size="sm" variant="outline" onClick={() => submit(a.code)} data-testid={`mc-submit-${a.code}`}>Submit</Button>
          </Card>
        ))}
      </div>
      <Card className="p-4">
        <div className="text-sm font-semibold heading mb-2">Pending on this Application</div>
        {pending.length === 0 ? <div className="text-sm text-muted-foreground">No pending items.</div> : (
          <ul className="divide-y divide-border">
            {pending.map(p => (
              <li key={p.id} className="py-2.5 flex items-center justify-between gap-3">
                <div>
                  <div className="font-medium text-sm">{p.action_description}</div>
                  <div className="text-[11px] text-muted-foreground mono">{p.action_type} · by {p.maker_name} ({p.maker_role}) · {fmtDate(p.requested_at)}</div>
                </div>
                <Badge variant="outline" className="text-warning border-warning/40">PENDING</Badge>
              </li>
            ))}
          </ul>
        )}
        <div className="mt-3 text-xs text-muted-foreground">Approve / Reject pending actions from <a href="/maker-checker" className="underline text-accent">Maker-Checker Queue</a>.</div>
      </Card>
    </div>
  );
}
